import withGeneralLayout from "@/components/Layouts/GeneralLayout";
import CivilEngineeringComponent from "@/components/Products/components/SubServices/CivilEngineeringComponent";
import React from "react";
import { SEO } from "@/components/SEO";

const CivilEngineering = () => {
  return (
    <div>
      <SEO
        title="Comprehensive Civil Engineering Services | Residential & Commercial Construction Experts | DreamCasa"
        description="DreamCasa provides top-tier civil engineering solutions, including structural design, site planning, and high-quality construction for residential and commercial projects."
        keywords="Civil Engineering Services, Structural Engineering, Residential Construction, Commercial Building, Infrastructure Development, DreamCasa Civil Engineering, Site Planning, Construction Management"
        URL="https://www.dreamcasarealestate.in/services/custom-builder/civilEngineering"
      />
      <CivilEngineeringComponent />
    </div>
  );
};

export default withGeneralLayout(CivilEngineering);
